import type { Incident, Track } from '@/api/types'
import { formatWhen, prettyStation } from '@/domain/format'
import { PipelineLg } from './Pipeline'
import { CotalkerLink, Fact, PriorityPill } from './atoms'

/** Sección 2 · Detalle de la incidencia. */
export function IncidentDetail({
  id,
  incident,
  track,
}: {
  id: string
  incident: Incident | null
  track: Track
}) {
  return (
    <section id={id} className="sec sec-incident" aria-labelledby="h-inc">
      <div className="sec-hd">
        <h2 id="h-inc">Detalle de la incidencia</h2>
      </div>
      <div className="sec-in">
        {!incident ? (
          <div className="placeholder">Elige una incidencia de la lista para ver su detalle.</div>
        ) : (
          <article className="card">
            <div className="hd-row">
              <div style={{ minWidth: 0 }}>
                <p className="eyebrow">Ticket {incident.ticket}</p>
                <h3 className="title-xl">{prettyStation(incident.station.display)}</h3>
                <p className="subtitle">
                  {incident.assetFamily.display} — {incident.ut.display}
                </p>
              </div>
              <div className="hd-actions">
                <PriorityPill priority={incident.priority} />
                <CotalkerLink channel={incident.channel} what="la incidencia" />
              </div>
            </div>

            <div className="facts">
              <Fact label="Actividad" value={incident.activity.display} />
              <Fact label="Activo" value={incident.asset.display} />
              <Fact label="Ubicación técnica" value={incident.ut.display} />
              <Fact label="Reportado" value={formatWhen(incident.createdAt)} numeric />
            </div>

            <p className="meta" style={{ marginBottom: 2 }}>
              Seguimiento de la incidencia
            </p>
            <PipelineLg state={incident.state} track={track} />
          </article>
        )}
      </div>
    </section>
  )
}
